import styled, { StyledProps } from 'styled-components/macro';

export const CheckLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export type CheckBoxStylesProps = StyledProps<{
  disabled?: boolean;
  checked: boolean
}>;

export const CheckBoxItem = styled.label`
  width: 16px;
  height: 16px;
  background: ${props => props.theme.colors.white};
  border: 1px solid #8795A2;
  box-sizing: border-box;
  box-shadow: inset 0px 0.6px 3px rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  cursor: pointer;
  transition: .2s;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  margin: 0 7px 0 0;
  cursor: pointer;

  &:focus {
    border: 1px solid #009BF0;
    box-shadow: inset 0px 0.6px 3px rgba(0, 0, 0, 0.5);
    outline: none;
  }

  &:hover {
    border: 1px solid #0076BF;
    box-shadow: inset 0px 0.6px 3px rgba(0, 0, 0, 0.5);
    outline: none;
  }

  svg {
    display: none;
  }
`;

export const CheckInput = styled.input`
  display: none;
  &:checked ~ ${CheckBoxItem} {
    background: ${(props) => props.theme.colors.blue};
    border: 1px solid #0076BF;
    box-shadow: 0 0 0;
    svg {
      display: block;
    }
  }
  &:disabled ~ ${CheckBoxItem} {
    background: #E6E6E6;
    border: 1px solid #D1D1D1;
    color: #BCBCBC;
    pointer-events: none;
  }
`;
